/**
 * Hero TS class for the Hero TCA-CE
 */

export class Hero
{

}

function applyHeightsMobile() {
  const sources = document.querySelectorAll<HTMLElement>(".source-height");

  if (window.innerWidth < 768) {
    sources.forEach(source => {

      const target_1 = document.querySelector<HTMLElement>(`.set-height[data-pair="1"]`);
      if (target_1) {
        const newHeight = source.offsetHeight + 5;
        target_1.style.height = `${newHeight}px`;
        // console.log(`MOBILE: Applied ${newHeight}px to target_1`);
      }

    });
    } else {
        sources.forEach(source => {
            const target_1 = document.querySelector<HTMLElement>(`.set-height[data-pair="1"]`);

            if (target_1) {
              const newHeight = source.offsetHeight + 80;
              target_1.style.height = `${newHeight}px`;
              // console.log(`DESKTOP: Applied ${newHeight}px to target_1`);
            }

          });

    }
}

window.addEventListener("load", applyHeightsMobile);
window.addEventListener("resize", applyHeightsMobile);

document.addEventListener('DOMContentLoaded', () => {
  // Selectors for Property Element

  const heroHeadline = document.querySelector<HTMLElement>('[data-ctype="iu_hero"] .js-hero-headline');
  const propertyItem = document.querySelector<HTMLElement>('.ce-iuproperties.ce-iuproperties-show');
  const heroImage = document.querySelector<HTMLImageElement>('[data-ctype="iu_hero"] .image-desktop>img');
  const heroImageMobile = document.querySelector<HTMLImageElement>('[data-ctype="iu_hero"] .image-mobile>img');

  if( !heroHeadline || !propertyItem || !heroImage || !heroImageMobile ) return;

  const propertyHeadline = propertyItem.querySelector<HTMLElement>('.property-headline');
  const propertyImage = propertyItem.querySelector<HTMLImageElement>('.header-image>img');
  const propertyImage2 = propertyItem.querySelector<HTMLImageElement>('.header-image>img');

  // Copy propertyHeadline
  if (propertyHeadline && propertyHeadline.textContent) {

    heroHeadline.textContent = propertyHeadline.textContent.trim();
  }

  // Copy the imageProperty
  if (propertyImage && propertyImage.src ) {
      // console.log("Substitution point!");
      heroImage.src = propertyImage.src;
      heroImage.srcset = propertyImage.srcset;
      heroImage.sizes = propertyImage.sizes;
  }

  // Copy the imageNews2
  if (heroImageMobile && propertyImage2) {
    heroImageMobile.src = propertyImage2.src;
    heroImageMobile.srcset = propertyImage2.srcset;
    heroImageMobile.sizes = propertyImage2.sizes;
  }

});

document.addEventListener('DOMContentLoaded', () => {
  // Selectors for Estate Element

  const heroHeadline = document.querySelector<HTMLElement>('[data-ctype="iu_hero"] .js-hero-headline');
  const estateItem = document.querySelector<HTMLElement>('.ce-iuestates.latest-props.ce-iuestates-show');
  const heroImage = document.querySelector<HTMLImageElement>('[data-ctype="iu_hero"] .image-desktop>img');
  const heroImageMobile = document.querySelector<HTMLImageElement>('[data-ctype="iu_hero"] .image-mobile>img');

  //console.log("Point 1x reached");

  //if( heroHeadline )  { console.log( "heroHeadline found" ); }
  //if( estateItem )  { console.log( "propertyItem found" ); }
  //if( heroImage )  { console.log( "heroImage found" ); }
  //if( heroImageMobile )  { console.log( "heroImageMobile found" ); }

  //console.log("Point 2x reached");

  if( !heroHeadline || !estateItem || !heroImage || !heroImageMobile ) return;

  const estateHeadline = estateItem.querySelector<HTMLElement>('.estate-title');
  const estateImage = estateItem.querySelector<HTMLImageElement>('.header-image>img');
  const estateImage2 = estateItem.querySelector<HTMLImageElement>('.header-image>img');

  //if( estateHeadline )  { console.log( "estateHeadline found" ); }
  //if( estateImage )     { console.log( "estateImage found" ); }

  // Copy estateHeadline
  if (estateHeadline && estateHeadline.textContent) {

    heroHeadline.textContent = estateHeadline.textContent.trim();
  }

  // Copy the imageEstate
  if (estateImage && estateImage.src ) {
      console.log("Substitution point!");
      heroImage.src = estateImage.src;
      heroImage.srcset = estateImage.srcset;
      heroImage.sizes = estateImage.sizes;
  }

  // Copy the imageNews2
  if (heroImageMobile && estateImage2) {
    heroImageMobile.src = estateImage2.src;
    heroImageMobile.srcset = estateImage2.srcset;
    heroImageMobile.sizes = estateImage2.sizes;
  }

});

document.addEventListener('DOMContentLoaded', () => {
  // Selectors for Hero and News elements

  const heroHeadline = document.querySelector<HTMLElement>('[data-ctype="iu_hero"] .js-hero-headline');
  const heroTag = document.querySelector<HTMLElement>('[data-ctype="iu_hero"] .js-hero-tag');
  const heroImage = document.querySelector<HTMLImageElement>('[data-ctype="iu_hero"] .image-desktop>img');
  const newsItem = document.querySelector<HTMLElement>('.news.news-single');

  if (!heroHeadline || !newsItem || !heroImage) return;

  const newsHeadline = newsItem.querySelector<HTMLElement>('.header h1[itemprop="headline"]');
  const newsImage = newsItem.querySelector<HTMLImageElement>('.mediaelement-image img[itemprop="image"]');
  const newsTagsElement = document.querySelector<HTMLElement>('.news-list-tags');

  // Copy the headlineNews
  if (newsHeadline && newsHeadline.textContent) {
    heroHeadline.textContent = newsHeadline.textContent.trim();
  }

  // Copy the imageNews
  if (newsImage && newsImage.src) {
    heroImage.src = newsImage.src;
    heroImage.srcset = newsImage.srcset;
    heroImage.sizes = newsImage.sizes;
  }

  // Copy heroTag
  if (heroTag && newsTagsElement) {
    const tagText = newsTagsElement.textContent?.trim();

    if (tagText && tagText.length > 0) {
      heroTag.textContent = tagText;              // Set the Hero tag text
      heroTag.style.display = 'inline-block';     // Make sure visible (if initially hidden)
      heroTag.style.opacity = '1';                // Optional: show it with style
    }
  }

});

function syncHeroWithNewsMagazin(): void {
  const hero = document.querySelector<HTMLElement>('[data-ctype="iu_hero"]');
  const newsItem = document.querySelector<HTMLElement>('.news.news-single');  
  const categoryTagElement = document.body.dataset.newsCategory; 

  if (!hero || !newsItem || !categoryTagElement) return;

  const heroHeadline = hero.querySelector<HTMLElement>('.js-hero-headline');
  const heroSubline = hero.querySelector<HTMLElement>('.js-hero-subline');
  const heroTag = hero.querySelector<HTMLElement>('.js-hero-tag');
  const heroImage = hero.querySelector<HTMLImageElement>('.image-desktop > img');
  const heroImageMobile = document.querySelector<HTMLImageElement>('[data-ctype="iu_hero"] .image-mobile>img');

  if (!heroHeadline || !heroImage || !heroImageMobile) return;

  const newsHeadline = newsItem.querySelector<HTMLElement>('.header h1[itemprop="headline"]');
  const newsSubline = newsItem.querySelector<HTMLElement>('.news-magazin-subline');
  const newsImage = newsItem.querySelector<HTMLImageElement>('.mediaelement-image img[itemprop="image"]');  
  const newsImage2 = newsItem.querySelector<HTMLImageElement>('.mediaelement-image img[itemprop="image"]');  
  const author = newsItem.querySelector<HTMLElement>('.news-author')?.textContent?.trim();
  const photographer = newsItem.querySelector<HTMLElement>('.news-photographer')?.textContent?.trim();

  // Build text parts
  const parts: string[] = [];

  // Headline
  if (newsHeadline?.textContent) {
    heroHeadline.textContent = newsHeadline.textContent.trim();
  }

  // Subline
  //if (heroSubline && newsSubline?.textContent) {
  //  heroSubline.textContent = newsSubline.textContent.trim();
  //}
  

  if (heroSubline) {
    if (newsSubline?.textContent) {
      heroSubline.textContent = newsSubline.textContent.trim();
      heroSubline.style.display = ''; // ensure visible
    } else {
      heroSubline.textContent = '';
      heroSubline.style.display = 'none';
    }
  }

  const metaEl = document.createElement('div');
  metaEl.className = 'hero-meta mt-4 flex flex-col gap-1';

  if (author) {
    parts.push(`Text: ${author}`);
  }

  if (photographer) {
    parts.push(`Fotos: ${photographer}`);
  }  

  if (author) {
    const authorEl = document.createElement('p');
    authorEl.className = 'hero-meta-item text-[14px] leading-[1.2]';

    authorEl.innerHTML = `<span class="font-semibold">› Text:</span> ${author}`;
    metaEl.appendChild(authorEl);
  }

  if (photographer) {
    const photoEl = document.createElement('p');
    photoEl.className = 'hero-meta-item text-[14px] leading-[1.2]';

    photoEl.innerHTML = `<span class="font-semibold">› Fotos:</span> ${photographer}`;
    metaEl.appendChild(photoEl);
  }

  // Decide where to insert meta
  const insertTarget =
    (heroSubline && newsSubline?.textContent)
      ? heroSubline
      : heroHeadline;

  // Insert meta
  if (parts.length > 0) {
    insertTarget.insertAdjacentElement('afterend', metaEl);
  }

  // Image
  if (newsImage?.src) {
    heroImage.src = newsImage.src;
    heroImage.srcset = newsImage.srcset;
    heroImage.sizes = newsImage.sizes;
  }

  // Image-mobile
  if (newsImage2?.src) {
    heroImageMobile.src = newsImage2.src;
    heroImageMobile.srcset = newsImage2.srcset;
    heroImageMobile.sizes = newsImage2.sizes;
  }

  // Tag
  if (heroTag && categoryTagElement) {
    // Optional: format (capitalize first letter)
    const formatted = categoryTagElement.charAt(0).toUpperCase() + categoryTagElement.slice(1);
    heroTag.textContent = formatted;
  }
}

document.addEventListener('DOMContentLoaded', syncHeroWithNewsMagazin);

